import styled from "@emotion/styled";
import { Component } from "react";

import { Add } from "@livechat/design-system-icons";
import { Button, Icon, SpacingToken } from "@livechat/design-system-react-components";

import Block from "components/layout/Block";
import Flex from "components/layout/Flex";
import { ModalPortal } from "components/modal";
import { TeamBadge } from "components/teams";
import { ITeam } from "store/entities/teams";
import { withVar } from "themes/helpers";

import { TeamsModal } from "./TeamsModal";

const TeamsList = styled.ul`
  position: relative;
  display: flex;
  flex-flow: row wrap;
  list-style: none;

  li {
    flex: 0 0 50%;
    max-width: 50%;
  }
`;

interface IProps {
  teams: ITeam[];
  value: string[];
  canManageAgentTeams: boolean;
  onChange(teamIds: string[]): void;
}

interface IState {
  isTeamsModalOpen: boolean;
}

export class AgentTeams extends Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);

    this.state = {
      isTeamsModalOpen: false,
    };
  }

  onConfirmTeamsModal = (teamIds: string[]): void => {
    this.props.onChange(teamIds);
    this.toggleTeamsModal();
  };

  toggleTeamsModal = (): void => {
    this.setState(prevState => ({
      isTeamsModalOpen: !prevState.isTeamsModalOpen,
    }));
  };

  render(): JSX.Element {
    const { canManageAgentTeams } = this.props;
    const teams = this.props.teams.filter(v => this.props.value.indexOf(v.id) !== -1);

    return (
      <Flex gap={withVar(SpacingToken.Spacing4)} column>
        <TeamsList>
          {teams.map(team => (
            <li key={team.id}>
              <TeamBadge id={team.id} name={team.name} />
            </li>
          ))}
        </TeamsList>
        {canManageAgentTeams && (
          <Block>
            <Button icon={<Icon source={Add} />} onClick={this.toggleTeamsModal} size="compact" kind="secondary">
              Choose team
            </Button>
          </Block>
        )}
        {this.state.isTeamsModalOpen && (
          <ModalPortal>
            <TeamsModal
              teams={this.props.teams}
              value={this.props.value}
              onConfirm={this.onConfirmTeamsModal}
              onCancel={this.toggleTeamsModal}
            />
          </ModalPortal>
        )}
      </Flex>
    );
  }
}
